<template>
    <div v-if="this.parcel">
        <!-- active -->
        <div
            :class="{
                'parcel-item': true,
                active: this.parcel.declaration,
            }"
        >
            <!-- <template v-if="this.parcel.declaration">
                <div class="checkbox mb-0" v-if="this.checkbox">
                    <label :for="`c${this.parcel.id}`">
                        <input
                            type="checkbox"
                            :id="`c${this.parcel.id}`"
                            @click="onChange"
                            :value="this.parcel"
                            :disabled="this.parcel.payment_status"
                        />

                        <div
                            :class="{
                                box: true,
                                disabled: this.parcel.payment_status,
                            }"
                        >
                            <svg
                                id="tick-circle"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    id="Vector"
                                    d="M0,2.83,2.83,5.66,8.5,0"
                                    transform="translate(7.75 9.17)"
                                    fill="none"
                                    stroke="#fff"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                ></path>
                                <path
                                    id="Vector-2"
                                    data-name="Vector"
                                    d="M0,0H24V24H0Z"
                                    fill="none"
                                    opacity="0"
                                ></path>
                            </svg>
                        </div>
                    </label>
                </div>
            </template>
            <template v-else-if="pageId == 3">
                <div style="width: 36px"></div>
            </template> -->

            <div class="icon">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.17004 7.43994L12 12.5499L20.77 7.46991"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M12 21.6099V12.5399"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M9.92999 2.48L4.59 5.45003C3.38 6.12003 2.39001 7.80001 2.39001 9.18001V14.83C2.39001 16.21 3.38 17.89 4.59 18.56L9.92999 21.53C11.07 22.16 12.94 22.16 14.08 21.53L19.42 18.56C20.63 17.89 21.62 16.21 21.62 14.83V9.18001C21.62 7.80001 20.63 6.12003 19.42 5.45003L14.08 2.48C12.93 1.84 11.07 1.84 9.92999 2.48Z"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M17 13.24V9.58002L7.51001 4.09998"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </div>
            <div class="parcel-item-inner" @click="modal = true">
                <div class="tracking">
                    <p>{{ this.parcel.tracking_number }}</p>

                    <span>
                        {{
                            this.parcel.barcode
                                ? this.parcel.barcode
                                : "ამანათი"
                        }}</span
                    >

                    <!-- <span>ამანათი  <span>ამანათი {{ this.parcel.barcode }}</span></span> -->
                </div>

                <!-- <div class="price" v-if="this.parcel.weight_price">
                    <span>ღირებულება</span>
                    <p>{{ this.parcel.weight_price }} ₾</p>
                </div> -->
                <div class="spacer"></div>

                <!-- {{ this.parcel.delivery }} -->

                <div class="status" v-if="this.parcel.clearance">
                    <p>ექვემდებარება გამბაჟებას</p>
                    <span v-if="this.parcel.file">ინვოისი ატვირთულია</span>
                    <span v-else>დეკლარაციაში ატვირთეთ ინვოისი</span>
                </div>

                <div class="spacer"></div>
                <div class="status">
                    <p>{{ this.parcel.flight.country.country }}</p>
                    <span v-if="this.parcel.declaration">დეკლარირებული</span>
                    <span v-else>დასადეკლარირებელი</span>
                </div>
            </div>
        </div>

        <div class=""></div>

        <transition name="fade">
            <declaration-info
                :parcel="this.parcel"
                v-if="modal"
                @close="modal = false"
                @declaration="declarationModal = true"
            />
        </transition>
        <transition name="fade">
            <declaration
                :parcel="this.parcel"
                :markets="marketsRef"
                v-if="declarationModal"
                @close="declarationModal = false"
                @declarationitems="declarationItemsAddModal = true"
                :country="this.country"
                :currency="this.currency"
            />
        </transition>
        <transition name="fade">
            <declarationItemsAdd
                v-if="declarationItemsAddModal"
                :parcel="this.parcel"
                :parcelTypes="this.parcelTypes"
                :country="this.country"
                :currency="this.currency"
                @close="
                    () => {
                        declarationItemsAddModal = false;
                        declarationModal = true;
                    }
                "
            />
        </transition>
    </div>
</template>

<script>
import {
    defineComponent,
    onBeforeMount,
    onMounted,
    ref,
    watch,
} from "@vue/composition-api";
import info from "../declaration/info.vue";
import declaration from "../declaration/declaration.vue";
import declarationItemsAdd from "../declaration/declarationItemsAdd.vue";
import { useParcels } from "../../hooks/parcels";
export default defineComponent({
    props: {
        checkbox: {
            type: Boolean,
            default: false,
        },
        parcel: {
            type: Object,
            default: null,
        },
        markets: {
            type: Array,
            default: null,
        },
        parcelTypes: {
            type: Array,
            default: null,
        },
        country: {
            type: Number,
            default: null,
        },
        currency: {
            type: Object,
            default: null,
        },
    },
    components: {
        "declaration-info": info,
        declaration,
        declarationItemsAdd,
    },
    setup(props, { emit }) {
        const marketsRef = ref(null);
        const { pageId } = useParcels();
        const modal = ref(false);
        const declarationModal = ref(false);
        const declarationItemsAddModal = ref(false);

        const BodyFix = (status) => {
            const body = document.body;

            if (status) {
                body.style.overflow = "hidden";
            } else {
                body.style.overflow = "scroll";
            }
        };
        watch(
            () => modal.value,
            (newVal, OldVal) => {
                BodyFix(newVal);
            }
        );
        watch(
            () => declarationModal.value,
            async (newVal, OldVal) => {
                await onMarkets(props.country);

                BodyFix(newVal);
            }
        );
        watch(
            () => declarationItemsAddModal.value,
            (newVal, OldVal) => {
                BodyFix(newVal);
            }
        );

        const onMarkets = async (id) => {
            let res = null;
            try {
                res = await axios({
                    method: "get",
                    url: "/api/markets",
                    params: {
                        country: id,
                    },
                });
                marketsRef.value = res.data;
            } catch (error) {
                console.log(error.response);
            }
        };

        const onChange = (e) => {
            emit("count", {
                type: e.target.checked,
                item: {
                    id: props.parcel.id,
                    price: props.parcel.weight_price,
                },
            });
        };

        onBeforeMount(() => {});

        return {
            onChange,
            props,
            modal,
            declarationModal,
            declarationItemsAddModal,
            pageId,
            marketsRef,
        };
    },
});
</script>
